import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type GetLineItemPaidPriceOptions = {
  lineItem: ReturnRequestLineItemDto;
  quantity?: number;
};

/**
 * This function will return the price paid by the custome
 * for a single element of a lineTtem.
 *
 * It also takes into account the taxes and discounts applied to the lineItem.
 *
 */
export function getLineItemPaidPrice({
  lineItem,
  quantity = 1,
}: GetLineItemPaidPriceOptions) {
  // Exchange-origin short-circuit: when the RR's order is itself a Baback
  // exchange order, `price` + `discountsAllocated` are poisoned by internal
  // credit allocations. Trust the resolver-populated upstream paid amount.
  // Mirrors backend `PricingComputationService.getPaidPrice`.
  const exchangeOriginPaidPrice = (
    lineItem as { exchangeOriginPaidPrice?: string | null }
  ).exchangeOriginPaidPrice;
  if (exchangeOriginPaidPrice != null && exchangeOriginPaidPrice !== "") {
    const parsed = parseFloat(exchangeOriginPaidPrice);
    return (Math.round((parsed + Number.EPSILON) * 100) / 100) * quantity;
  }

  let price = parseFloat(lineItem.price);

  lineItem.unitTaxes.forEach((tax) => {
    // `refundable !== false` and not `=== true` (BBS-342): the field is absent
    // on every line written before the setting existed, and absent means
    // refundable.
    if (!tax.includedInPrice && tax.refundable !== false) {
      price += tax.amount;
    }
  });

  lineItem.discountsAllocated.forEach((discount) => {
    if (discount.allocationMethod === "EACH") {
      price -= discount.amount / lineItem.quantity_bought;
    } else if (discount.allocationMethod == "ACROSS") {
      price -= discount.amount / lineItem.quantity_bought;
    }
  });

  price = Math.round((price + Number.EPSILON) * 100) / 100;

  return price * quantity;
}
